const fmt = (d) => `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-${String(d.getDate()).padStart(2, "0")}`;

export function periodPresets() {
  const now = new Date();
  const y = now.getFullYear();
  const m = now.getMonth();
  const first = (yy, mm) => new Date(yy, mm, 1);
  const last = (yy, mm) => new Date(yy, mm + 1, 0);
  return [
    { key: "this", label: "Este mês", from: fmt(first(y, m)), to: fmt(last(y, m)) },
    { key: "prev", label: "Mês anterior", from: fmt(first(y, m - 1)), to: fmt(last(y, m - 1)) },
    { key: "l3", label: "Últimos 3 meses", from: fmt(first(y, m - 2)), to: fmt(last(y, m)) },
    { key: "l6", label: "Últimos 6 meses", from: fmt(first(y, m - 5)), to: fmt(last(y, m)) },
    { key: "year", label: "Ano atual", from: fmt(new Date(y, 0, 1)), to: fmt(new Date(y, 11, 31)) },
  ];
}

export const defaultPeriod = () => {
  const p = periodPresets()[0];
  return { from: p.from, to: p.to };
};
